import Grid from "@mui/material/Grid2"
import Paper from "@mui/material/Paper"
import React from "react"
import { useAppSelector } from "@store/hooks"
import { refreshLeagueData } from "./helpers"
import MiniTable from "./MiniTable"

const name = "Leaderboards"

const Leaderboards: React.FC = () => {
    const statistics = useAppSelector(({ state }) => state.UsersStatistics)
    const [data, setData] = React.useState<{
        name: string;
        data: unknown[];
    }[] | undefined>([])

    React.useEffect(() => {
        if (statistics && statistics.length > 0) {
            setData(refreshLeagueData(statistics))
        }
    }, [statistics])

    return (
        (<Grid container direction="column" justifyContent="center" alignItems="center" flexBasis="18%" flexGrow={1} >
            <Paper elevation={4} >
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}><p style={{ textAlign: "center", margin: "0px", padding: "6px" }} >Leaderboards</p></Grid>
                <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={0.5} sx={{ m: -1, height: "33.85rem" }}>
                    {data?.map((data, idx) => (<Grid
                        key={idx}
                        size={{
                            xs: 5,
                            sm: 5
                        }}>
                        <MiniTable key={idx} data={data} inverted={["Abandoned Rate", "Reduced Rate"].includes(data.name)} />
                    </Grid>))}
                </Grid>
            </Paper>
        </Grid>)
    );
}

Leaderboards.displayName = name

export default React.memo(Leaderboards)
